var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h2',{staticClass:"heading"},[_vm._t("default"),_vm._v(" "),_c('div',{staticClass:"loadmore-btn"},[_vm._t("loadmore")],2)],2)}
var staticRenderFns = []

export { render, staticRenderFns }